import { useCallback, useState } from "react";

/**
 * Hook for managing panel modal state. Returns the active modal key,
 * a setter, and a `modalProps` helper that generates `isOpen`/`onOpenChange`
 * props for modal components.
 */
export function usePanelModals<T extends string>() {
  const [activeModal, setActiveModal] = useState<T | undefined>();

  const modalProps = useCallback(
    (key: T) => ({
      isOpen: activeModal === key,
      onOpenChange: (open: boolean) => setActiveModal(open ? key : undefined),
    }),
    [activeModal],
  );

  return { activeModal, setActiveModal, modalProps } as const;
}
